import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { applyGoogleConsent, initSignupTracking, isSignupTrackingPage, readGoogleConsent } from '@/lib/googleAds';

export function SignupTrackingConsent() {
  useEffect(() => {
    initSignupTracking();
  }, []);
  const { t } = useTranslation('auth');
  const [choice, setChoice] = useState(readGoogleConsent);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);
  if (!isSignupTrackingPage()) return null;
  const save = (analytics: boolean, marketing: boolean) => {
    const next = { analytics, marketing };
    applyGoogleConsent(next);
    setChoice(next);
  };
  if (choice)
    return (
      <button className='mt-4 text-xs underline' onClick={() => setChoice(null)}>
        {t('tracking.settings')}
      </button>
    );
  return (
    <section aria-label={t('tracking.title')} className='mt-4 rounded-lg border bg-background p-4 text-sm'>
      <h2 className='font-semibold'>{t('tracking.title')}</h2>
      <p className='my-2'>
        {t('tracking.description')}{' '}
        <a className='underline' href='https://skygis.cloud/privacy'>
          {t('login.privacyPolicy')}
        </a>
      </p>
      <div className='flex gap-4 my-3'>
        <label>
          <input type='checkbox' checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />{' '}
          {t('tracking.analytics')}
        </label>
        <label>
          <input type='checkbox' checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />{' '}
          {t('tracking.marketing')}
        </label>
      </div>
      <div className='flex flex-wrap gap-2'>
        <Button type='button' variant='outline' onClick={() => save(false, false)}>
          {t('tracking.reject')}
        </Button>
        <Button type='button' variant='outline' onClick={() => save(analytics, marketing)}>
          {t('tracking.save')}
        </Button>
        <Button type='button' onClick={() => save(true, true)}>
          {t('tracking.accept')}
        </Button>
      </div>
    </section>
  );
}
